export default "__VITE_ASSET___Fm87FeT__"